import Swiper from 'swiper';


export default class {
    constructor(){
        
        this.imageSliderItem = new Swiper('.js-image__slider', {
            loop: true,
            speed:3000,
            loopAdditionalSlides : 5,
            slidesPerView: 2,
            spaceBetween: 0,
            allowTouchMove:false,
            simulateTouch:false,
            centeredSlides: false,
            autoplay: {
                delay: 0,
            },
            freeMode: true,

            breakpoints: {
                
                575: {
                    slidesPerView: 3,
                },
                767: {
                    slidesPerView: 4,
                }
            },
        })
            
        window.addEventListener("resize",this.resize);

    }
    resize(){
        const imageSliderEl = document.querySelector('.js-image__slider')
        if(imageSliderEl){
            if(this.imageSliderItem){
                this.imageSliderItem.autoplay.start()
            }
        }
    }
}
